export default "__VITE_ASSET__2b11252e__"